import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { useI18n } from "../../i18n";

const CATEGORY_DATA = [
  { slug: "home-living", en: "Home & Living", nl: "Wonen", img: "https://images.unsplash.com/photo-1567016376408-0226e4d0c1ea?w=600&auto=format&fit=crop", desc_en: "Linen, ceramics, lighting", desc_nl: "Linnen, keramiek, verlichting" },
  { slug: "smart-gadgets", en: "Smart Gadgets", nl: "Slimme Gadgets", img: "https://images.unsplash.com/photo-1650682009477-52fd77302b78?w=600&auto=format&fit=crop", desc_en: "Hubs, audio, chargers", desc_nl: "Hubs, audio, opladers" },
  { slug: "pet-products", en: "Pet Products", nl: "Huisdier", img: "https://images.unsplash.com/photo-1753826944253-76cd9e60cd04?w=600&auto=format&fit=crop", desc_en: "Beds, leashes, bowls", desc_nl: "Bedden, riemen, schalen" },
  { slug: "kitchen-accessories", en: "Kitchen", nl: "Keuken", img: "https://images.unsplash.com/photo-1779387733080-8d8654b24802?w=600&auto=format&fit=crop", desc_en: "Cookware, boards, ceramics", desc_nl: "Pannen, planken, keramiek" },
  { slug: "car-accessories", en: "Car", nl: "Auto", img: "https://images.unsplash.com/photo-1533630217389-3a5e4dff5683?w=600&auto=format&fit=crop", desc_en: "Mounts, leather, covers", desc_nl: "Houders, leer, hoezen" },
];

const FEATURED_LINKS_EN = ["New arrivals", "Best sellers", "Sale", "Gift cards"];
const FEATURED_LINKS_NL = ["Nieuw binnen", "Bestsellers", "Sale", "Cadeaubonnen"];

const MegaMenu = () => {
  const { lang, t } = useI18n();
  const [open, setOpen] = useState(false);
  const featured = lang === "nl" ? FEATURED_LINKS_NL : FEATURED_LINKS_EN;

  return (
    <div
      className="relative"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      data-testid="mega-menu"
    >
      <button
        data-testid="mega-menu-trigger"
        className="flex items-center gap-1 text-sm hover:text-terracotta transition-colors py-2"
      >
        {t("nav_shop")} <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      <div
        className={`absolute left-1/2 -translate-x-1/2 top-full pt-3 transition-all duration-300 ${open ? "opacity-100 pointer-events-auto translate-y-0" : "opacity-0 pointer-events-none -translate-y-2"}`}
        style={{ width: "min(1100px, 90vw)" }}
      >
        <div className="bg-white border border-black/10 shadow-[0_30px_60px_-30px_rgba(0,0,0,0.2)]">
          <div className="grid grid-cols-12 gap-8 p-8">
            <div className="col-span-3 border-r border-black/5 pr-6">
              <div className="font-label text-ink-muted mb-4">{t("nav_categories")}</div>
              <ul className="space-y-3">
                {CATEGORY_DATA.map((c) => (
                  <li key={c.slug}>
                    <Link
                      to={`/shop?category=${c.slug}`}
                      data-testid={`mega-link-${c.slug}`}
                      onClick={() => setOpen(false)}
                      className="block group"
                    >
                      <div className="font-display text-lg group-hover:text-terracotta transition-colors">{lang === "nl" ? c.nl : c.en}</div>
                      <div className="text-xs text-ink-muted">{lang === "nl" ? c.desc_nl : c.desc_en}</div>
                    </Link>
                  </li>
                ))}
              </ul>
              <div className="mt-6 pt-4 border-t border-black/5">
                <div className="font-label text-ink-muted mb-3">{lang === "nl" ? "Uitgelicht" : "Featured"}</div>
                <ul className="space-y-2 text-sm">
                  {featured.map((f, i) => (
                    <li key={i}>
                      <Link to="/shop" onClick={() => setOpen(false)} className="hover:text-terracotta">{f}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-span-9 grid grid-cols-3 gap-4">
              {CATEGORY_DATA.slice(0, 3).map((c) => (
                <Link
                  key={c.slug}
                  to={`/shop?category=${c.slug}`}
                  onClick={() => setOpen(false)}
                  className="editorial-image relative aspect-[4/5] block group"
                >
                  <img src={c.img} alt="" className="w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                  <div className="absolute bottom-4 left-4 right-4 text-white">
                    <div className="font-display text-2xl">{lang === "nl" ? c.nl : c.en}</div>
                    <div className="text-xs opacity-80 mt-1">{lang === "nl" ? c.desc_nl : c.desc_en}</div>
                    <div className="mt-2 font-label opacity-0 group-hover:opacity-100 transition-opacity">{t("nav_shop")} →</div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
          <div className="bg-secondary-warm px-8 py-4 flex items-center justify-between text-xs font-label">
            <span>★ {lang === "nl" ? "Gratis verzending vanaf €50 — PostNL & DHL" : "Free shipping from €50 — PostNL & DHL"}</span>
            <span className="text-terracotta">iDEAL · Klarna · Card · Apple Pay · Google Pay</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MegaMenu;
